import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: () => import('../layouts/MainLayout.vue'),
    redirect: '/dashboard',
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue')
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('../views/users/UserList.vue')
      },
      {
        path: 'inspections',
        name: 'Inspections',
        component: () => import('../views/inspections/InspectionList.vue')
      },
      {
        path: 'inspections/:id',
        name: 'InspectionDetail',
        component: () => import('../views/inspections/InspectionDetail.vue')
      },
      {
        path: 'repairs',
        name: 'Repairs',
        component: () => import('../views/repairs/RepairList.vue')
      },
      {
        path: 'repairs/:id',
        name: 'RepairDetail',
        component: () => import('../views/repairs/RepairDetail.vue')
      },
      {
        path: 'constructions',
        name: 'Constructions',
        component: () => import('../views/constructions/ConstructionList.vue')
      },
      {
        path: 'constructions/:id',
        name: 'ConstructionDetail',
        component: () => import('../views/constructions/ConstructionDetail.vue')
      },
      {
        path: 'emergencies',
        name: 'Emergencies',
        component: () => import('../views/emergencies/EmergencyList.vue')
      },
      {
        path: 'emergencies/:id',
        name: 'EmergencyDetail',
        component: () => import('../views/emergencies/EmergencyDetail.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

function isTokenValid(token) {
  if (!token) return false
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.exp * 1000 > Date.now()
  } catch (e) {
    return false
  }
}

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  const valid = isTokenValid(token)
  
  if (to.meta.requiresAuth && !valid) {
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    next('/login')
  } else if (to.path === '/login' && valid) {
    next('/')
  } else {
    next()
  }
})

export default router

